import React from "react";

import classNames from "classnames";
import styles from "../../styles/new-search-widget.module.scss";
import {DropdownArrowDown} from "../../../../core/components/dropdown/dropdown-arrow-down";
import {DropdownArrowUp} from "../../../../core/components/dropdown/dropdown-arrow-up";
import {observer} from "mobx-react";
import {COLORS} from "../../../../core/app/consts/colors";
import {useThemeColor} from "../../../../infrastructure/hooks/useThemeColor";

export const NewSearchWidgetSportsFilterHeader = observer(({controller, onClick}) => {
  const {state} = controller;
  const {selectedSport, searchModelsExists, isSportTypeMenuOpen, isSportTypesDropdownHighlighted} = state;
  const color: String = useThemeColor(searchModelsExists ? COLORS.accentPrimary : COLORS.textSecondary);
  const isDropdownOpen: Boolean = searchModelsExists && isSportTypeMenuOpen;

  const sportFilterProps = {
    className: classNames(styles.sport_filter, {[styles.sport_filter_disable]: !searchModelsExists, [styles.tab_section]: isSportTypesDropdownHighlighted}),
    onClick: () => searchModelsExists && onClick?.()
  }

  return (
    <div {...sportFilterProps}>
      {selectedSport?.name}
      {
        isDropdownOpen ? <DropdownArrowUp color={color}/> : <DropdownArrowDown color={color}/>
      }
    </div>
  )
});
